import { Grid, Paper, Typography, makeStyles } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import { devDocLinks } from './devDocLinks';
import Icon from '@mdi/react';

const useStyles = makeStyles(theme => ({
  gridItem: {
    display: 'flex',
  },
  link: {
    display: 'flex',
    flex: 1,
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  paper: {
    padding: theme.spacing(1),
    margin: theme.spacing(1.25),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[4],
    },
  },
  linkContent: {
    display: 'flex',
    marginBottom: theme.spacing(1),
    alignItems: 'center',
  },
  icon: {
    float: 'left',
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  externalIcon: {
    float: 'right',
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  title: {
    display: 'block',
    fontWeight: 'bold',
    fontSize: '1rem',
    color: theme.palette.primary.main,
  },
}));

export const DevDocs = () => {
  const classes = useStyles();

  return (
    <Grid container direction="row" spacing={0}>
      {devDocLinks.map((link, index) => {
        return (
          <Grid item xs={12} sm={6} key={index} className={classes.gridItem}>
            <Link to={link.link} className={classes.link}>
              <Paper className={classes.paper} aria-label={link.title}>
                <div className={classes.linkContent}>
                  <Icon path={link.icon} size={1} className={classes.icon} aria-hidden="true" />
                  <Typography className={classes.title}>
                    {link.title}
                    {link.externalIcon && (
                      <Icon
                        path={link.externalIcon!}
                        size={1}
                        className={classes.externalIcon}
                        aria-hidden="true"
                      />
                    )}
                  </Typography>
                </div>
              </Paper>
            </Link>
          </Grid>
        );
      })}
    </Grid>
  );
};
